module.exports = __webpack_public_path__ + "static/media/faqBalance-es-zh.057f5b0e.vtt";